import React from 'react';
import UserAccountComponent from '../../components/users/UserAccount';

export default () => {
  return <UserAccountComponent />;
};
